import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m226-226-92 92q-19 19-44 9-24-10-24-36v-654q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H226Zm-26-79h615v-510H145v571l55-61Zm-55 0v-510 510Z"/>',
  f: '<path d="m226-226-92 92q-19 19-44 9-24-9-24-36v-654q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H226Z"/>',
};

export default data;
